import { defineStore } from 'pinia';
import { EGameSideBarTab } from '~/types/gamePage';
import type { ISsCentrifugeMaxBetChannel } from '~/types/softswiss/ssCentrifuge';
import type { ISsGame } from '~/types/softswiss/ssGames';

const defaultState = {
  gameScreenMode: 1 as 1 | 2 | 4,
  openedGames: [{}, {}, {}, {}] as [ISsGame, ISsGame, ISsGame, ISsGame],
  gameToOpen: null as null | ISsGame,
  maxBetRestrictedMessages: [null, null, null, null] as Array<ISsCentrifugeMaxBetChannel | null>,
  sidebarActiveTab: EGameSideBarTab.Tournament as EGameSideBarTab,
};

export const useStoreGamePageData = defineStore('gamePageData', {
  state: () => ({
    ...defaultState,
  }),
  getters: {
    screenMode(state) {
      return state.gameScreenMode;
    },
    selectedGames(state) {
      return state.openedGames;
    },
    openedGamesHasEmptySlot(state) {
      return state.openedGames.slice(0, state.gameScreenMode).some((game) => !game.id);
    },
    isSidebarOpened(state) {
      return state.sidebarActiveTab !== EGameSideBarTab.none;
    },
  },
  actions: {
    setScreenMode(value: 1 | 2 | 4) {
      this.gameScreenMode = value;
    },
    setSelectedGame(game: ISsGame, position: number) {
      this.openedGames.splice(position, 1, game);
    },
    setGameToOpen(game: ISsGame | null) {
      this.gameToOpen = game;
    },
    setMaxBetRestrictedMessage(msg: ISsCentrifugeMaxBetChannel | null) {
      if (msg && msg.reason === 'bonus_bet_limit_exceeded') {
        const screenNumberWithError = this.openedGames.findIndex(
          (game) => game.externalId === msg.game
        );
        if (screenNumberWithError !== -1) {
          this.maxBetRestrictedMessages.splice(screenNumberWithError, 1, msg);
        }
      }
    },
    updateMaxBetRestrictedMessage(msg: ISsCentrifugeMaxBetChannel | null, position: number) {
      this.maxBetRestrictedMessages.splice(position, 1, msg);
    },
    resetSelectedGames() {
      this.openedGames = [{}, {}, {}, {}] as [ISsGame, ISsGame, ISsGame, ISsGame];
    },

    setActiveTab(tab: EGameSideBarTab) {
      this.sidebarActiveTab = tab;
      useCookie('sidebarState').value = tab;
    },

    clearStore() {
      Object.assign(this, { defaultState, sidebarActiveTab: this.sidebarActiveTab });
    },
  },
});
